import React, { useEffect, useRef } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const PasswordStep = ({ email, organisation, password, error, busy, organisations, onPasswordChange, onSubmit, onChooseOrganisation, onBack }) => {
  const headingRef = useRef(null);
  useEffect(() => headingRef.current?.focus(), [organisations.length]);

  if (organisations.length) {
    return (
      <div className="enterprise-auth-step">
        <p className="enterprise-auth-kicker">Verified account</p>
        <h2 ref={headingRef} tabIndex="-1">Choose your workspace</h2>
        <p className="enterprise-auth-intro">Your credentials are linked to more than one organisation.</p>
        <div className="enterprise-auth-choice-list">
          {organisations.map((item) => (
            <button key={item.id} type="button" className="enterprise-auth-choice" aria-busy={busy} onClick={() => onChooseOrganisation(item.id)}>
              <span className="enterprise-auth-avatar" aria-hidden="true">{item.name?.slice(0, 2).toUpperCase()}</span>
              <span>{item.name}</span><ArrowRight size={17}/>
            </button>
          ))}
        </div>
        {error && <p className="enterprise-auth-error" role="alert">{error}</p>}
        <button type="button" className="enterprise-auth-back" onClick={onBack}><ArrowLeft size={16}/>Back</button>
      </div>
    );
  }

  return (
    <div className="enterprise-auth-step">
      <p className="enterprise-auth-kicker">Password sign-in</p>
      <h2 ref={headingRef} tabIndex="-1">Enter your password</h2>
      {organisation && <div className="enterprise-auth-organisation"><span className="enterprise-auth-avatar">{organisation.initials}</span><span>{organisation.name}</span></div>}
      <p className="enterprise-auth-account">{email}</p>
      <form onSubmit={onSubmit} noValidate>
        <label htmlFor="auth-password">Password</label>
        <input id="auth-password" data-testid="login-password" type="password" autoComplete="current-password" autoFocus value={password} onChange={(event) => onPasswordChange(event.target.value)} aria-invalid={Boolean(error)} aria-describedby={error ? 'auth-password-error' : undefined} />
        {error && <p id="auth-password-error" className="enterprise-auth-error" role="alert">{error}</p>}
        <button className="enterprise-auth-primary" data-testid="login-submit-btn" type="submit" aria-busy={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
      </form>
      <div className="enterprise-auth-row-links">
        <button type="button" className="enterprise-auth-back" onClick={onBack}><ArrowLeft size={16}/>Use another email</button>
        <Link to="/forgot-password">Forgot password?</Link>
      </div>
    </div>
  );
};

export default PasswordStep;
